import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

function DefaultSettingsInput({
  fieldName,
  fieldValue,
  containerClass,
  labelText,
  labelClass,
  changeValue,
  onButtonClick,
}) {
  return (
    <div className={`d-flex align-items-center ${containerClass}`}>
      <div className={`bo-same-line bo-w-240 ${labelClass}`}>
        <Form.Label>{labelText}</Form.Label>
      </div>
      <div className="bo-same-line">
        <Form.Control
          min={0}
          onKeyDown={e => {
            if (e.key === '-') {
              e.preventDefault();
            }
          }}
          className="bo-input"
          type={fieldValue === null ? 'text' : 'number'}
          name={fieldName}
          id={fieldName}
          readOnly={fieldValue === null}
          value={fieldValue !== null ? fieldValue : 'Default'}
          onChange={changeValue}
        />
      </div>
      <div className="bo-same-line px-0">
        <Button
          className="bo-button-inline-link"
          onClick={() => onButtonClick(fieldName, fieldValue)}
        >
          {fieldValue !== null ? 'Reset to Default' : 'Override Default'}
        </Button>
      </div>
    </div>
  );
}

export default DefaultSettingsInput;
